export default [
  {
    title: 'Ayuda',
    route: 'public-faq',
    icon: 'HelpCircleIcon',
  },
]
